import React from 'react';
import withStyles from '../../../../core/isomorphic-style-loader/withStyles';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './InsuranceMiniCard.css' or it... Remove this comment to see the full error message
import s from './InsuranceMiniCard.css';
import { getFullNameFromCamelCaseProps } from '../../../../core/util/account';

type Props = {
  insuranceCarrierName?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  memberId?: string;
  insurerType?: string;
  size?: string;
  status?: string;
  handleReplaceInsurance?: (...args: any[]) => any;
};
const InsuranceMiniCard = (props: Props) => (
  <div className={s.root} onClick={props.handleReplaceInsurance}>
    <div className={s.edit}>
      <div>Replace</div>
    </div>

    <div className={s.carrierInfo}>
      {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
      <div className={s.insurerType}>{props.insurerType.toUpperCase()} </div>

      <div className={s.insuranceCarrierName}>{props.insuranceCarrierName}</div>
    </div>

    <div className={s.userInfo}>
      <div className={s.name}>
        Name:
        {getFullNameFromCamelCaseProps(props)}
      </div>

      <div className={s.separationBlock} />

      <div className={s.memberId}>
        Member ID:
        {props.memberId}
      </div>
    </div>
  </div>
);

export default withStyles(s)(InsuranceMiniCard);
